import { ElementRef } from "@angular/core";
import { Observable } from "rxjs";
import { MapsLoaderService } from "../../services/maps-loader.service";
import { GeoLocationService } from "../../services/geo-location.service";
import { GoogleGeolocationResponseModel } from "../../viewModels/google-geo-location-response-model";

export class BaseMap {
  protected map: google.maps.Map;
  protected defaultZoom = 15;

  protected isMobile;

  constructor(
    protected readonly mapsLoaderService: MapsLoaderService,
    protected readonly geoLocationService: GeoLocationService
  ) {}

  get gmap(): google.maps.Map {
    return this.map;
  }

  protected get googleMapsAPIs(): Observable<any> {
    return this.mapsLoaderService.loadGoogleMapsAPIs();
  }

  protected initMapObservable(mapContainer: ElementRef<HTMLElement>, mapOptions: google.maps.MapOptions): Observable<void> {
    return new Observable<void>((observer) => {
        this.googleMapsAPIs.subscribe(() => {
          this.initMap(mapContainer, mapOptions);
          observer.next();
        })
      }
    );
  }

  protected initMapCallback(mapContainer: ElementRef<HTMLElement>, mapOptions: google.maps.MapOptions, callback: () => void): void {
    this.googleMapsAPIs.subscribe(() => {
      this.initMap(mapContainer, mapOptions);
      callback();
    });
  }

  protected initMap(mapContainer: ElementRef<HTMLElement>, mapOptions: google.maps.MapOptions): void {
    let mapParams: google.maps.MapOptions = {
      mapId: this.mapsLoaderService.mapConfiguration.map_id,
      zoom: 1,
      maxZoom: 22,
      center: new google.maps.LatLng(0, 0),
      controlSize: 26,
      mapTypeControlOptions: {
        mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain'],
        position: google.maps.ControlPosition.BOTTOM_CENTER,
      },
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      gestureHandling: 'cooperative',
      clickableIcons: false,
    };

    if(mapOptions) {
      mapParams = {
        ...mapParams,
        ...mapOptions
      };
    }

    this.map = new google.maps.Map(mapContainer.nativeElement, mapParams);
  }

  protected initMyLocation(callback: (location: google.maps.LatLngLiteral) => void) {
    if (this.isMobile) {
      this.geoLocationService.getPosition().subscribe((position: any) => {
        const location = {
          lat: position.coords.latitude as number,
          lng: position.coords.longitude as number
        };
        callback(location);
      });
    } else {
      this.geoLocationService.getPositionFromGoogleGeolocationAPI().subscribe((response: GoogleGeolocationResponseModel) => {
        const location = {
          lat: response.location.lat,
          lng: response.location.lng
        }
        callback(location);
      });
    }
  }
}
